import {
  ReservationAgreeButton,
  type ReservationAgreeButtonMessages,
} from "../../ui/buttons/reservation-agree-button";

import { NoticeItem } from "./shared";

export type Ichinomiya2ndSpecialTermsMessages = {
  title: string;
  description: string;
  checkInSection: { title: string; notices: string[] };
  facilityRulesSection: { title: string; notices: string[] };
  neighborConsiderationSection: { title: string; notices: string[] };
  agreeButtonLabel: string;
  agreeButtonMessages?: ReservationAgreeButtonMessages;
};

const JA_MESSAGES: Ichinomiya2ndSpecialTermsMessages = {
  title: "一宮2nd特別ルールへのご協力のお願い",
  description:
    "一宮は海の近くの静かな町です。近隣の皆さんと互いに気持ちよく過ごすため、いくつかのルールを設けています。必ずご一読いただき、ご理解の上で滞在をお楽しみいただけると幸いです。",
  checkInSection: {
    title: "チェックイン時間と駐車場のご利用について",
    notices: [
      "チェックイン時間は21:00までです",
      "施設付近の路上駐車はおやめください",
      "駐車場での大きな音での車のドアの開閉、アイドリングはご遠慮ください",
    ],
  },
  facilityRulesSection: {
    title: "施設利用のルールについて",
    notices: [
      "21:00以降はお静かにお過ごしください",
      "敷地内における喫煙・花火・焚火・BBQは禁止です",
    ],
  },
  neighborConsiderationSection: {
    title: "近隣の方への配慮を忘れずに",
    notices: [
      "近隣私有地への無断立ち入りは禁止です",
      "近隣住宅が写った写真や動画のSNS等への投稿はお控えください",
    ],
  },
  agreeButtonLabel: "一宮2nd特別ルールに同意します",
};

export function Ichinomiya2ndSpecialTerms({
  agreed,
  setAgreed,
  messages = JA_MESSAGES,
}: {
  agreed: boolean;
  setAgreed: (value: boolean) => void;
  messages?: Ichinomiya2ndSpecialTermsMessages;
}) {
  return (
    <div className="bg-slightblue font-notojp text-skogecha mt-[30px] flex w-full flex-col items-center py-[30px] md:py-[60px]">
      <div className="max-w-[690px] space-y-[20px] px-[30px] md:px-0">
        <div className="space-y-[10px]">
          <div className="text-sm font-bold">{messages.title}</div>
          <div className="text-[13px] leading-[180%]">
            {messages.description}
          </div>
        </div>
        <ol className="list-inside space-y-[20px] text-xs [counter-reset:list-number]">
          <NoticeItem
            title={messages.checkInSection.title}
            notices={messages.checkInSection.notices}
          />
          <NoticeItem
            title={messages.facilityRulesSection.title}
            notices={messages.facilityRulesSection.notices}
          />
          <NoticeItem
            title={messages.neighborConsiderationSection.title}
            notices={messages.neighborConsiderationSection.notices}
          />
        </ol>
        <div className="flex justify-center py-[11px] text-sm">
          <ReservationAgreeButton
            label={messages.agreeButtonLabel}
            required
            checked={agreed}
            onToggle={setAgreed}
            testId="ichinomiya2nd-special-terms-agree-button"
            messages={messages.agreeButtonMessages}
          />
        </div>
      </div>
    </div>
  );
}
